import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <div>
        <p className="text-xs flex justify-end bottom-0 pr-1">
          PP-ATI-IND-0243 on 25/4/2023
        </p>
      </div>
    );
  }
}
export default Footer;
